import { render, staticRenderFns } from "./BCXItemsWithPoints.vue?vue&type=template&id=9964abd4&scoped=true"
import script from "./BCXItemsWithPoints.vue?vue&type=script&lang=ts"
export * from "./BCXItemsWithPoints.vue?vue&type=script&lang=ts"
import style0 from "./BCXItemsWithPoints.vue?vue&type=style&index=0&id=9964abd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9964abd4",
  null
  
)

export default component.exports